import { gql } from '@apollo/client';
import { MESSAGE_FRAGMENT } from './queries';

/**
 * Subscription to receive new messages from bot
 */
export const MESSAGE_RECEIVED = gql`
  ${MESSAGE_FRAGMENT}
  subscription MessageReceived {
    messageReceived {
      ...MessageFields
    }
  }
`;

/**
 * Subscription to receive chat title updates
 */
export const CHAT_TITLE_UPDATED = gql`
  subscription ChatTitleUpdated {
    chatTitleUpdated {
      title
      messageId
    }
  }
`;

/**
 * Subscription to receive progressive bot pipeline events
 */
export const BOT_STREAM_RECEIVED = gql`
  subscription BotStreamReceived {
    botStreamReceived {
      type
      stage
      publicId
      title
      text
      answer
      images
      files
      transferredToExperts
    }
  }
`;
